export const formatEmailsToArray = (input: string): string[] => {
  let emails = input.split(',').map((e) => e.trim())
  if (!input.includes(',') && input.includes(' ')) {
    emails = input
      .replace(/\s\s+/g, ' ')
      .split(' ')
      .map((e) => e.trim())
  }
  return emails.filter(Boolean)
}

export const validateEmails = (emailsInput: string): string | null => {
  if (!emailsInput.length) return null

  const emailArray = formatEmailsToArray(emailsInput)
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  const invalidEmails = emailArray.filter((email) => !emailRegex.test(email))

  if (invalidEmails.length > 0) {
    return invalidEmails.join(', ') === ''
      ? 'Extra comma or space found in invite list'
      : `Invalid email: ${invalidEmails.join(', ')}`
  }

  return null
}
